export default {
  getCategory: (state) => state.category,
  getCategories: (state) => state.categories,
  getCategoriesMap: (state) => {
    let categoriesMap = {};
    (state.categories || []).forEach((category) => {
      categoriesMap[category.id] = { ...category };
    });
    return categoriesMap;
  },
};
